import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Col, Row, Table } from 'reactstrap';
import { Translate, ICrudGetAllAction, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { IRootState } from 'app/shared/reducers';
import { getEntities } from './wechat-user-2.reducer';
import { IWechatUser2 } from 'app/shared/model/wechat-user-2.model';
import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';

export interface IWechatUser2Props extends StateProps, DispatchProps, RouteComponentProps<{ url: string }> {}

export const WechatUser2 = (props: IWechatUser2Props) => {
  useEffect(() => {
    props.getEntities();
  }, []);

  const { wechatUser2List, match, loading } = props;
  return (
    <div>
      <h2 id="wechat-user-2-heading">
        <Translate contentKey="examsysApp.wechatUser2.home.title">Wechat User 2 S</Translate>
        <Link to={`${match.url}/new`} className="btn btn-primary float-right jh-create-entity" id="jh-create-entity">
          <FontAwesomeIcon icon="plus" />
          &nbsp;
          <Translate contentKey="examsysApp.wechatUser2.home.createLabel">Create new Wechat User 2</Translate>
        </Link>
      </h2>
      <div className="table-responsive">
        {wechatUser2List && wechatUser2List.length > 0 ? (
          <Table responsive>
            <thead>
              <tr>
                <th>
                  <Translate contentKey="global.field.id">ID</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.nickName">Nick Name</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.avatarUrl">Avatar Url</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.gender">Gender</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.country">Country</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.province">Province</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.city">City</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.language">Language</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.openid">Openid</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.createDate">Create Date</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.token">Token</Translate>
                </th>
                <th>
                  <Translate contentKey="examsysApp.wechatUser2.tel">Tel</Translate>
                </th>
                <th />
              </tr>
            </thead>
            <tbody>
              {wechatUser2List.map((wechatUser2, i) => (
                <tr key={`entity-${i}`}>
                  <td>
                    <Button tag={Link} to={`${match.url}/${wechatUser2.id}`} color="link" size="sm">
                      {wechatUser2.id}
                    </Button>
                  </td>
                  <td>{wechatUser2.nickName}</td>
                  <td>{wechatUser2.avatarUrl}</td>
                  <td>{wechatUser2.gender}</td>
                  <td>{wechatUser2.country}</td>
                  <td>{wechatUser2.province}</td>
                  <td>{wechatUser2.city}</td>
                  <td>{wechatUser2.language}</td>
                  <td>{wechatUser2.openid}</td>
                  <td>
                    {wechatUser2.createDate ? (
                      <TextFormat type="date" value={wechatUser2.createDate} format={APP_LOCAL_DATE_FORMAT} />
                    ) : null}
                  </td>
                  <td>{wechatUser2.token}</td>
                  <td>{wechatUser2.tel}</td>
                  <td className="text-right">
                    <div className="btn-group flex-btn-group-container">
                      <Button tag={Link} to={`${match.url}/${wechatUser2.id}`} color="info" size="sm">
                        <FontAwesomeIcon icon="eye" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.view">View</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${wechatUser2.id}/edit`} color="primary" size="sm">
                        <FontAwesomeIcon icon="pencil-alt" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.edit">Edit</Translate>
                        </span>
                      </Button>
                      <Button tag={Link} to={`${match.url}/${wechatUser2.id}/delete`} color="danger" size="sm">
                        <FontAwesomeIcon icon="trash" />{' '}
                        <span className="d-none d-md-inline">
                          <Translate contentKey="entity.action.delete">Delete</Translate>
                        </span>
                      </Button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        ) : (
          !loading && (
            <div className="alert alert-warning">
              <Translate contentKey="examsysApp.wechatUser2.home.notFound">No Wechat User 2 S found</Translate>
            </div>
          )
        )}
      </div>
    </div>
  );
};

const mapStateToProps = ({ wechatUser2 }: IRootState) => ({
  wechatUser2List: wechatUser2.entities,
  loading: wechatUser2.loading,
});

const mapDispatchToProps = {
  getEntities,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(WechatUser2);
